function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Caminho_532",
  "data-name": "Caminho 532",
  d: "M0,0H44.942V44.942H0Z",
  fill: "none"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Caminho_533",
  "data-name": "Caminho 533",
  d: "M35.707,7.745H20.726L16.981,4H5.745A3.74,3.74,0,0,0,2.019,7.745L2,30.216a3.756,3.756,0,0,0,3.745,3.745H35.707a3.756,3.756,0,0,0,3.745-3.745V11.49A3.756,3.756,0,0,0,35.707,7.745Zm0,22.471H5.745V11.49H35.707Z",
  transform: "translate(1.745 3.49)",
  fill: "#1D3054"
});

function SvgPastaRiva(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "folder_open_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.942,
    height: 44.941,
    viewBox: "0 0 44.942 44.941",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPastaRiva);
export default __webpack_public_path__ + "static/media/pastaRiva.63712a87.svg";
export { ForwardRef as ReactComponent };